import { createContext, useContext, useMemo } from 'react';
import { VizContainerRootProps } from '../root';

// NOTE: for now, this context is separate from `VizPanelContextProvider` to avoid impacting
// the existing `VizPanel` production use cases during early development of `VizContainer`. We
// hopefully can merge some or all of this functionality with `VizPanelContextProvider` when we
// merge `VizPanel` and `VizContainer`.

interface VizContainerContextValue extends Pick<Required<VizContainerRootProps>, 'disablePadding' | 'variant'> {}

const VizContainerContext = createContext<VizContainerContextValue | undefined>(undefined);

export interface VizContainerContextProviderProps extends VizContainerContextValue {
  children: React.ReactNode;
}

export function VizContainerContextProvider({ children, variant, disablePadding }: VizContainerContextProviderProps) {
  const value: VizContainerContextValue = useMemo(() => {
    return { variant, disablePadding };
  }, [disablePadding, variant]);

  return <VizContainerContext.Provider value={value}>{children}</VizContainerContext.Provider>;
}

export const useVizContainerContext = () => {
  const context = useContext(VizContainerContext);
  if (!context) {
    throw new Error('Missing VizContainerContextProvider.');
  }
  return context;
};
